var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loaded
      ? _c("div", { staticClass: "form-row" }, [
          !_vm.readonly
            ? _c(
                "div",
                { staticClass: "col form-group input-group" },
                [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c(
                      "div",
                      { staticClass: "input-group-text" },
                      [
                        _c("ItpIcon", {
                          attrs: { icon: "material-symbols:calendar-month" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("ItpFormSelect", {
                    attrs: {
                      name: "selectedRuleID",
                      options: _vm.rules,
                      valueField: "id",
                      textField: "rule.description",
                      placeholder: _vm._f("pgettext")(
                        "Select predefined rule to add.",
                        "BillingDateRule"
                      )
                    },
                    model: {
                      value: _vm.selectedRuleID,
                      callback: function($$v) {
                        _vm.selectedRuleID = $$v
                      },
                      expression: "selectedRuleID"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group-append" },
                    [
                      _c("ItpButton", {
                        attrs: {
                          variant: "light",
                          icon: "fa-plus",
                          tooltip: _vm._f("pgettext")(
                            "Add rule configuration",
                            "BillingDateRule"
                          ),
                          disabled: !_vm.selectedRuleID
                        },
                        on: {
                          click: function($event) {
                            return _vm.evh_4207795475682514_click($event, {})
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", { staticClass: "form-row" }, [
          _c(
            "div",
            { staticClass: "col-md-5 form-group" },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "reference_month",
                  options: _vm.referenceMonthOptions,
                  valueField: "value",
                  textField: "name",
                  required: "",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.reference_month,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "reference_month", $$v)
                  },
                  expression: "item.reference_month"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-4 form-group" },
            [
              _c("ItpFormSelect", {
                attrs: {
                  name: "day_specifier",
                  options: _vm.daySpecifierOptions,
                  valueField: "value",
                  textField: "name",
                  required: "",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.day_specifier,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "day_specifier", $$v)
                  },
                  expression: "item.day_specifier"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-3 input-group form-group" },
            [
              _c("ItpFormInput", {
                ref: "offsetDays",
                attrs: {
                  type: "number",
                  name: "day_value",
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.day_value,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "day_value", $$v)
                  },
                  expression: "item.day_value"
                }
              }),
              _vm._v(" "),
              _c("DIV", { staticClass: "input-group-append" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("pgettext")("day", "InputGroupAddon")) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", { staticClass: "form-row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("ItpFormInput", {
                attrs: {
                  name: "description",
                  placeholder: _vm._f("pgettext")(
                    "Rule description",
                    "ExchangeRateDateRule"
                  ),
                  readonly: _vm.readonly
                },
                model: {
                  value: _vm.item.description,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "description", $$v)
                  },
                  expression: "item.description"
                }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }